import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { importsByIdStatusGetSlice } from './get';

export const importsByIdStatusReducers = combineReducers({
	get: importsByIdStatusGetSlice.asyncReducers
});

export const importsByIdStatusWatchers = combineAllWatchers([
	importsByIdStatusGetSlice.asyncWatchers
]);
